import type { ReactNode } from "react";

export const BREED_BACK_LINK_CLASS =
    "text-label text-doberman-black/50 underline underline-offset-3";

export function BreedPageBody({
    breedName,
    backLink,
    searchButton,
}: {
    breedName: string;
    backLink: ReactNode;
    searchButton: ReactNode;
}) {
    return (
        <div className="mx-auto flex w-full max-w-3xl flex-col gap-8 px-6 py-12">
            <div className="flex flex-col gap-3">
                {backLink}
                <h1 className="text-display-title text-doberman-black">
                    {breedName}
                </h1>
                <p className="text-body text-doberman-black/60">
                    Full breed profile coming soon &mdash; traits, health info,
                    care guides, and breeders.
                </p>
            </div>
            <div className="flex flex-col gap-4 card-lg bg-havanese">
                <p className="text-item-title text-doberman-black">
                    Find {breedName} near you
                </p>
                <p className="text-body text-doberman-black/70">
                    Browse available {breedName} puppies and dogs from shelters,
                    rescues, and breeders in your area.
                </p>
                {searchButton}
            </div>
        </div>
    );
}
